import ENV from "config/Env";
import { backendQueryKey } from "hooks/useTypedQuery";

type WoWidgetResponse = {
  button_label: string;
  redirect_url: string;
  service_box_wo_2: string;
  service_box_wo_2_name: string;
};

const component = "PSA";

export const PsaQueryKeys = {
  appointmentWidget: backendQueryKey<WoWidgetResponse | null>({ component, baseUrl: ENV.dealerBaseURL, endpoint: "/servicebox/widget/wo" }),
  carWidget: backendQueryKey<WoWidgetResponse | null>({ component, baseUrl: ENV.dealerBaseURL, endpoint: "/servicebox/widget/car" })
};
